'use client';

import type { Treatment } from '@/app/utils/experimentation';
import { useEffect } from 'react';
import { getSuperProp } from '@/app/utils/experimentation';
import { useTracking } from '@/components/tracking-provider';

export interface TrackTreatmentProps {
  treatment: Treatment;
}

// Sends a pageview event to the tracker once, when the component mounts.
export default function TrackTreatment({ treatment }: TrackTreatmentProps) {
  const tracker = useTracking();

  useEffect(() => {
    tracker.setSuperProps(getSuperProp(treatment));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
